export default __webpack_public_path__ + "static/media/Belt of the Reanimator.11700ff5.jpg";